// we need our modal component
import FinishResult from './FinishResult.vue';

const FinishModal = {
  // every plugin for Vue.js needs install method
  // this method will run after Vue.use(<your-plugin-here>) is executed
  install (Vue, options) {
    // We must create new Eventbus
    // which is just another Vue instance that will be listening for and emitting events from our main instance
    // this EventBus will be available as Modal.EventBus
    this.EventBus = new Vue();

    // making our modal component global
    Vue.component('finish-result', FinishResult);

    // exposing global $modal object with method show()
    // method show() takes object params as argument
    // inside this object we can have modal title, text, styles... and also our callback confirm function
    Vue.prototype.$finishResult = {
      show (params) {
        // if we use this.$modal.show(params) inside our original Vue instance
        // we will emit 'show' event with parameters 'params'
        FinishModal.EventBus.$emit('show', params);
      },
      handleResults (results, onSuccess, onRetry, onFail) {
        console.log(0, results);
        FinishModal.EventBus.$emit('handleResults', results, onSuccess, onRetry, onFail);
      },
      /**
       *
       * @param results
       * @returns {Promise<string>}
       */
      async handleResultsAsync (results) {
        return new Promise((resolve, reject) => {
          FinishModal.EventBus.$emit('handleResultsAsync', results, resolve, reject);
        });
      }
    };
  }
};

export default FinishModal;
